import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement } from './getExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement';

/**
 * 프로젝트 링크인 경우 추가 정보 (우리 사이트 내부 링크)
 */
export type GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfo = {
  /** 프로젝트 참여 통계 */
  engagement?: GetExploreContent200PageAllOfThreeContentItemContentOneOfMediaLinksItemProjectInfoEngagement;
  /** 프로젝트 ID */
  projectId?: number;
};
